module.exports = __webpack_public_path__ + "static/img/8.132a532.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/8.png
// module id = PTHj
// module chunks = 1